import React from 'react';
import { Box } from '@mui/material';

interface CalendarContainerProps {
  children: React.ReactNode;
  /** Fill the caller's slot, or use an explicit height when embedded. */
  height?: string | number;
}

const CalendarContainer = React.forwardRef<HTMLDivElement, CalendarContainerProps>(
  ({ children, height = '100%' }, ref) => {
    return (
      <Box
        ref={ref}
        data-testid="calendar-widget"
        sx={{
          height,
          minHeight: 0,
          minWidth: 0,
          display: 'flex',
          flex: '1 1 0',
          flexDirection: 'column',
          borderRadius: 4,
          position: 'relative',
        }}
      >
        {children}
      </Box>
    );
  },
);

CalendarContainer.displayName = 'CalendarContainer';

export default CalendarContainer;
